import { useEffect, useState } from "react";
import API from "../../api/api";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";


export default function Availability() {


  const [availability, setAvailability] = useState([]);

  const [slots, setSlots] = useState([]);
  

  const [showSlotModal, setShowSlotModal] = useState(false);
const [showAvailabilityModal, setShowAvailabilityModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
const [selectedSlots, setSelectedSlots] = useState([]);
const [savingAvailability, setSavingAvailability] = useState(false);


  const [newSlot, setNewSlot] = useState({
    name:"",
    start_time:"",
    end_time:"",
    color:"#22c55e"
  });



  /* ================= LOAD AVAILABILITY ================= */

  const load = async()=>{

    try{

      const res =
      await API.get("/guide/availability");


      setAvailability(
        Array.isArray(res.data)
        ? res.data
        : []
      );


    }catch(err){

      console.error(err);

    }

  };





  /* ================= LOAD SAVED SLOTS ================= */

  const loadSlots = async()=>{


    try{


      const res =
      await API.get("/guide/slots");


      setSlots(
        Array.isArray(res.data)
        ? res.data
        : []
      );


    }catch(err){

      console.error(err);

    }


  };





  useEffect(()=>{

    load();

    loadSlots();

  },[]);

  /* ================= CREATE SLOT ================= */

  const createSlot = async()=>{


    try{


      await API.post(
        "/guide/slots",
        newSlot
      );


      setNewSlot({

        name:"",
        start_time:"",
        end_time:"",
        color:"#22c55e"

      });


      setShowSlotModal(false);


      loadSlots();



    }catch(err){

      console.error(err);

    }


  };


const handleDateClick = (info) => {

  const date = info.dateStr;

  setSelectedDate(date);

  const existingForDate = availability.filter(a =>
    String(a.start_datetime).substring(0, 10) === date
  );

  const matchedSlotIds = slots
    .filter(slot =>
      existingForDate.some(a =>
        (a.title || "") === slot.name &&
        String(a.start_datetime).substring(11, 16) === slot.start_time &&
        String(a.end_datetime).substring(11, 16) === slot.end_time
      )
    )
    .map(slot => slot.id);

  setSelectedSlots(matchedSlotIds);

  setShowAvailabilityModal(true);
};

const toggleSlot = (slotId) => {

  setSelectedSlots(prev => {

    if (prev.includes(slotId)) {
      return prev.filter(id => id !== slotId);
    }

    return [...prev, slotId];

  });

};

const saveAvailability = async () => {

  if (!selectedDate) return;

  setSavingAvailability(true);

  try {

    const existingForDate = availability.filter(a =>
      String(a.start_datetime).substring(0, 10) === selectedDate
    );

    /*
      Remove availability that was unchecked
    */

    for (const existing of existingForDate) {

      const matchingSlot = slots.find(slot =>
        (existing.title || "") === slot.name &&
        String(existing.start_datetime).substring(11, 16) === slot.start_time &&
        String(existing.end_datetime).substring(11, 16) === slot.end_time
      );

      if (
        matchingSlot &&
        !selectedSlots.includes(matchingSlot.id)
      ) {

        await API.delete(
          `/guide/availability/${existing.id}`
        );

      }

    }

    /*
      Add newly selected slots
    */

    for (const slotId of selectedSlots) {

      const slot = slots.find(s => s.id === slotId);

      if (!slot) continue;

      const alreadyExists = existingForDate.some(existing =>
        (existing.title || "") === slot.name &&
        String(existing.start_datetime).substring(11, 16) === slot.start_time &&
        String(existing.end_datetime).substring(11, 16) === slot.end_time
      );

      if (!alreadyExists) {

        await API.post(
          "/guide/availability",
          {
            title: slot.name,

            start_datetime:
              `${selectedDate} ${slot.start_time}`,

            end_datetime:
              `${selectedDate} ${slot.end_time}`
          }
        );

      }

    }

    await load();

    setShowAvailabilityModal(false);

  } catch (err) {

    console.error(err);

  } finally {

    setSavingAvailability(false);

  }

};

const deleteSlot = async (id) => {

  if (!window.confirm("Delete this saved slot?")) {
    return;
  }

  try {

    await API.delete(
      `/guide/slots/${id}`
    );

    await loadSlots();

  } catch (err) {

    console.error(err);

  }

};
 

  /* ================= EXISTING EVENTS ================= */


  const calendarEvents = availability.map(a=>({


    id:a.id,


    title:a.title || "Available",


    start:a.start_datetime,


    end:a.end_datetime,


    backgroundColor:"#22c55e",


    borderColor:"#22c55e"



  }));






  return (

<div style={page}>


<h2>
My Availability
</h2>



<div style={layout}>


  


{/* ================= SIDEBAR ================= */}


<div style={sidebar}>


<h3>
My Slots
</h3>



<button
style={button}
onClick={() => setShowSlotModal(true)}
>
+ Create Slot
</button>




<div style={{ marginTop: 20 }}>


{

slots.map(slot=>(


<div

key={slot.id}






style={{
...slotBox,
borderLeft:`5px solid ${slot.color}`
}}

>


<b>
{slot.name}
</b>


<div style={{fontSize:12}}>

{slot.start_time}
-
{slot.end_time}

</div>


<button

onClick={()=>deleteSlot(slot.id)}

style={{
marginTop:8,
fontSize:11,
background:"#ef4444",
color:"white",
border:"none",
borderRadius:5,
padding:"3px 8px",
cursor:"pointer"
}}

>
Delete
</button>


</div>


))

}



</div>


</div>





{/* ================= CALENDAR ================= */}


<div style={calendarBox}>


<FullCalendar
  plugins={[
    dayGridPlugin,
    timeGridPlugin,
    interactionPlugin
  ]}

  initialView="dayGridMonth"

  headerToolbar={{
    left: "prev,next today",
    center: "title",
    right: "dayGridMonth,timeGridWeek,timeGridDay"
  }}

  dateClick={handleDateClick}



  events={calendarEvents}

  slotMinTime="06:00:00"
  slotMaxTime="22:00:00"

  height="auto"
/>


</div>



</div>








{/* ================= CREATE SLOT MODAL ================= */}


{showSlotModal &&


<div style={modalOverlay}>


<div style={modal}>


<h3>
Create Slot
</h3>



<input

placeholder="Slot name"

value={newSlot.name}

onChange={
e=>setNewSlot({
...newSlot,
name:e.target.value
})
}

/>




<label>
Start
</label>


<input

type="time"

value={newSlot.start_time}

onChange={
e=>setNewSlot({
...newSlot,
start_time:e.target.value
})
}

/>



<label>
End
</label>


<input

type="time"

value={newSlot.end_time}

onChange={
e=>setNewSlot({
...newSlot,
end_time:e.target.value
})
}

/>





<button
style={button}
onClick={createSlot}
>
Save Slot
</button>



<button

style={cancel}

onClick={() => setShowSlotModal(false)}

>
Cancel
</button>



</div>


</div>

}

{/* ================= DATE AVAILABILITY MODAL ================= */}

{showAvailabilityModal && (

  <div style={modalOverlay}>

    <div style={availabilityModal}>

      <h3 style={{ marginTop: 0 }}>
        Availability
      </h3>

      <div style={{
        fontSize: 14,
        color: "#64748b",
        marginBottom: 15
      }}>
        {selectedDate}
      </div>

      <div style={{
        display: "flex",
        flexDirection: "column",
        gap: 10,
        maxHeight: 350,
        overflowY: "auto"
      }}>

        {slots.length === 0 && (

          <div style={{
            padding: 15,
            background: "#f8fafc",
            borderRadius: 8,
            color: "#64748b"
          }}>
            No saved availability slots yet.
          </div>

        )}

        {slots.map(slot => (

          <label
            key={slot.id}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "12px 14px",
              border: "1px solid #e2e8f0",
              borderRadius: 10,
              cursor: "pointer",
              background: selectedSlots.includes(slot.id)
                ? "#f0fdf4"
                : "white"
            }}
          >

            <input
              type="checkbox"
              checked={selectedSlots.includes(slot.id)}
              onChange={() => toggleSlot(slot.id)}
            />

            <div>

              <div style={{
                fontWeight: 600
              }}>
                {slot.name}
              </div>

              <div style={{
                fontSize: 12,
                color: "#64748b"
              }}>
                {slot.start_time} – {slot.end_time}
              </div>

            </div>

          </label>

        ))}

      </div>

      <div style={{
        display: "flex",
        justifyContent: "flex-end",
        gap: 10,
        marginTop: 20
      }}>

        <button
          style={cancel}
          onClick={() => setShowAvailabilityModal(false)}
          disabled={savingAvailability}
        >
          Cancel
        </button>

        <button
          style={button}
          onClick={saveAvailability}
          disabled={savingAvailability}
        >
          {savingAvailability
            ? "Saving..."
            : "Save Availability"}
        </button>

      </div>

    </div>

  </div>

)}

</div>

  );

}







/* ================= STYLES ================= */


const page={

padding:20,

background:"#f8fafc",

minHeight:"100vh"

};



const layout={

display:"grid",

gridTemplateColumns:"260px 1fr",

gap:20

};



const sidebar={

background:"white",

padding:20,

borderRadius:15,

boxShadow:"0 4px 20px rgba(0,0,0,.05)"

};



const calendarBox={

background:"white",

padding:20,

borderRadius:15

};



const slotBox={

padding:12,

marginBottom:10,

background:"#f8fafc",

borderRadius:10,

cursor:"default"

};



const button={

background:"#22c55e",

color:"white",

border:"none",

padding:"10px 15px",

borderRadius:8,

cursor:"pointer"

};



const cancel={

marginLeft:10,

padding:"10px 15px",

borderRadius:8,

border:"1px solid #ddd",

background:"white"

};



const modalOverlay = {

position:"fixed",

top:0,
left:0,
right:0,
bottom:0,

background:"rgba(0,0,0,.45)",

display:"flex",

alignItems:"center",

justifyContent:"center",

zIndex:9999

};



const modal = {

background:"white",

padding:25,

borderRadius:15,

width:350,

display:"flex",

flexDirection:"column",

gap:12,

zIndex:10000

};

const availabilityModal = {
  background: "white",
  padding: 25,
  borderRadius: 15,
  width: 420,
  maxWidth: "90vw",
  maxHeight: "80vh",
  display: "flex",
  flexDirection: "column",
  zIndex: 10000
};